import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Datatable from '../../../ExtraComponents/ReusableTable1';
import { PencilLine, Trash2 } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import {
    getChargeBasisbyId
} from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";


const History = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const agent_id = JSON.parse(localStorage.getItem("agent_id"));
    const token = localStorage.getItem("token");
    const [chargeBasisData, setChargeBasisData] = useState([]);

    useEffect(() => {
        viewChargeBasis()
    }, []);

    const viewChargeBasis = async () => {
        setChargeBasisData(location?.state?.data?.ChargeBasisHistories || []);
    };

    const DateFarmet = (newDate) => {
        const date = new Date(newDate);
        const formattedDate = format(date, 'eee, MMM d, yyyy h:mm a');
        return formattedDate;
    }


    const columns = [
        {
            name: "History",
            cell: (row) => (
                <>
                    <div>
                        <p>
                            {row.history}
                        </p>
                        <p>
                            {DateFarmet(row?.createdAt)}
                        </p>
                    </div>

                </>
            ),
            selector: (row) => row.history,
            sortable: true,
        },
        {
            name: "Description",
            cell: (row) => (row?.description).replaceAll('_', ' '),
            selector: (row) => row.description,
            sortable: true,
        },

    ];

    return (
        <div>
            <section className="section dashboard">
                <div className="row">
                    <div className='dark-table-thead'>
                        <Datatable
                            columns={columns}
                            data={chargeBasisData && chargeBasisData || []}
                            filter={false}
                        />
                    </div>
                </div>
            </section>

        </div>
    );
};

export default History;
